import React from 'react'
import { Sidenav, Nav, Icon } from 'rsuite'
import './styles.less'

export default function SidebarLoadingTemplate() {
  return (
    <div className={'rs-sidebar-media-backdrop media-sidebar-show'}>
      <div className={'sidebar-loading-template rs-sidebar-wrapper fixed'}>
        <Sidenav>
          <Sidenav.Body>
            <Nav>
              {new Array(10).fill().map((_, index) => {
                return (
                  <Nav.Item
                    key={index}
                    eventKey={index}
                    icon={<Icon icon={'square'} style={{ color: '#f2f2f5' }} />}
                    disabled
                  >
                    <div className="template__text"></div>
                  </Nav.Item>
                )
              })}
            </Nav>
          </Sidenav.Body>
        </Sidenav>
      </div>
    </div>
  )
}
